import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const savePreRegistrationData = async (userEmail, mobileNumber, sessionData) => {
  console.log('sessionDatabhojwani', sessionData);
  try {
    const url = `${baseUrl}/BioFuelThirdPartyIntegration/api/SimplifiedKYC/SavePreRegistrationData`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        user_Email: sessionData?.personalInformation?.email || sessionData?.personalInformation?.phone || null,
        mobile_Number: sessionData?.personalInformation?.phone || null,
        pan_Verification_JsonData: sessionData?.businessDetails?.fullValidatedInfo?.pan
          ? JSON.stringify(sessionData.businessDetails.fullValidatedInfo.pan)
          : null,
        gst_Verification_JsonData: sessionData?.businessDetails?.fullValidatedInfo?.gst
          ? JSON.stringify(sessionData.businessDetails.fullValidatedInfo.gst)
          : null,
        driving_License_Verification_JsonData: sessionData?.businessDetails?.fullValidatedInfo?.individual
          ? JSON.stringify(sessionData.businessDetails.fullValidatedInfo.individual)
          : null,
        bank_Verification_JsonData: sessionData?.bankDetails?.fullBankVerified
          ? JSON.stringify(sessionData.bankDetails.fullBankVerified)
          : null,
        udyog_Aadhaar_JsonData: sessionData?.msmeRegistration?.fullVerifiedInfo
          ? JSON.stringify(sessionData.msmeRegistration.fullVerifiedInfo)
          : null,
        location_JsonData: sessionData?.operationDetails?.location
          ? JSON.stringify(sessionData.operationDetails.location)
          : null,
        session_Json_data: JSON.stringify({
          ...sessionData?.personalInformation,
          UserTypeEnum: 1,
          businessType: sessionData?.businessDetails?.businessTypeEnumName,
          buyerSellerType: sessionData?.businessDetails?.buyerSellerTypeEnumName,
          date_of_birth: sessionData?.personalInformation?.date_of_birth,
          gstNumber: sessionData?.businessDetails?.gstNumber,
          hasGST: sessionData?.businessDetails?.hasGST,
          hasIndividualDL: sessionData?.businessDetails?.hasIndividualDL,
          hasPAN: sessionData?.businessDetails?.hasPAN,
          individualId: sessionData?.businessDetails?.individualId,
          natureOfBusiness: sessionData?.businessDetails?.natureOfBusinessEnumName,
          typeOfIndividual: sessionData?.businessDetails?.typeOfIndividualEnumName,
          panNumber: sessionData?.businessDetails?.panNumber,
          msmeNumber: sessionData?.msmeRegistration?.msmeNumber,
        }),
      }),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-preRegistration-savePreRegistrationData->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SavePreRegistrationData');
    throw errors;
  }
};

export const fetchPreRegistrationData = async (userName, mobileNumber) => {
  try {
    const url = `${baseUrl}/BioFuelThirdPartyIntegration/api/SimplifiedKYC/FetchPreRegistrationData`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        userName,
        mobileNumber,
      }),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-preRegistration-fetchPreRegistrationData->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchPreRegistrationData');
    throw errors;
  }
};

export const registerAutomatedKYCUser = async (sessionData, isMobile, isIPad) => {
  console.log('registerAutomatedKYCUser sessionData:', sessionData);
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/SimplifiedKYC/RegisterAutomatedKYCUser`;

    // Extract firstName and lastName from selectedSignatory if isVerifiedPerson is "yes"
    let firstName = null;
    let lastName = null;
    const isUsingSignatory =
      sessionData?.operationDetails?.isVerifiedPerson === 'yes' && !!sessionData?.operationDetails?.selectedSignatory;

    if (isUsingSignatory) {
      const fullName = sessionData.operationDetails.selectedSignatory.trim();
      const nameParts = fullName.split(' ');

      if (nameParts.length > 0) {
        firstName = (nameParts[0] || '').trim() || null; // First word or null
        const remaining = nameParts.slice(1).join(' ').trim();
        lastName = remaining.length > 0 ? remaining : ''; // null if empty
      }
    }

    let setEnum;
    if (isMobile) {
      setEnum = 3;
    } else if (isIPad) {
      setEnum = 4;
    } else {
      setEnum = 2;
    }

    // Build the payload based on the curl request structure
    const payload = {
      access_method_type_enum: setEnum,
      otp: sessionData?.personalInformation?.otp || null,
      emailOtp: sessionData?.personalInformation?.emailOtp || null,
      phoneVerified: sessionData?.personalInformation?.phoneVerified || null,
      emailVerified: sessionData?.personalInformation?.emailVerified || null,
      business_Type_Enum: sessionData?.businessDetails?.businessTypeEnumName || null,
      buyer_Seller_Enum: sessionData?.businessDetails?.buyerSellerTypeEnumName || null,
      gender_Enum: sessionData?.personalInformation?.gender || null,
      hasGST: sessionData?.businessDetails?.hasGST || null,
      hasIndividualDL: sessionData?.businessDetails?.hasIndividualDL || null,
      hasPAN: sessionData?.businessDetails?.hasPAN || null,
      first_Name: isUsingSignatory ? firstName : sessionData?.personalInformation?.firstName || null,
      middle_Name: sessionData?.personalInformation?.middleName || null,
      last_Name: isUsingSignatory ? lastName : sessionData?.personalInformation?.lastName || null,
      user_Email: sessionData?.personalInformation?.email || null,
      mobile_Number: sessionData?.personalInformation?.phone || null,
      gstin_Number: sessionData?.businessDetails?.gstNumber || null,
      entity_Pan: sessionData?.businessDetails?.panNumber || null,
      user_Type_Enum: 1 || null,
      nature_Of_Business_Enum: sessionData?.businessDetails?.natureOfBusinessEnumName || null,
      bank_Account_Number: sessionData?.bankDetails?.accountNumber || null,
      bank_Account_IFSC: sessionData?.bankDetails?.ifsc || null,
      type_Of_Individual_Enum: sessionData?.businessDetails?.typeOfIndividualEnumName || null,
      Is_Proprietor:
        sessionData?.businessDetails?.typeOfIndividualEnumName === 'DriverAndVehicleOwner'
          ? !!sessionData?.businessDetails?.isProprietor
          : false,
      Udyam_Aadhar_Number: sessionData?.msmeRegistration?.msmeNumber || null,
    };

    console.log('Register API payload:', payload);

    const res = await utils.fetch(url, {
      method: 'POST',
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json-patch+json',
      },
      body: JSON.stringify(payload),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-preRegistration-registerAutomatedKYCUser->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'RegisterAutomatedKYCUser');
    throw errors;
  }
};

export default {
  savePreRegistrationData,
  fetchPreRegistrationData,
  registerAutomatedKYCUser,
};
